import useModulePager from "Hooks/useModulePager";
import { LocationSearchRequest, SearchClient, VenueSearchResult, WorkspaceSearchResult } from "Services/API/API";
import { useApiClient } from "Services/API/useApiClient";
import ModulePager from "features/EnterprisePortal/Components/ModulePager";
import ModulePagerControls from "features/EnterprisePortal/Components/ModulePager/ModulePagerControls";
import React, { useEffect, useState } from "react";
import classes from "./styles.module.scss";
import WorkspaceCard from "Components/WorkspaceCard";
import classNames from "classnames";
import useMediaBreakpointUp from "Hooks/useMediaBreakpointUp";

interface Item {
   venue: VenueSearchResult;
   workspace: WorkspaceSearchResult;
}

interface SpacesYouMayAlsoLikeProps {
   latitude: number;
   longitude: number;
}

const SpacesYouMayAlsoLike: React.FC<SpacesYouMayAlsoLikeProps> = ({ latitude, longitude }) => {
   const searchClient = useApiClient(SearchClient);

   const [data, setData] = useState<Item[]>([]);

   const isXXL = useMediaBreakpointUp("xxl");
   const isXL = useMediaBreakpointUp("xl");
   const isLG = useMediaBreakpointUp("lg");

   const pager = useModulePager(
      isXXL
         ? {
            itemCount: 10,
            itemWidth: 307,
            gapWidth: 30
         }
         : isXL
            ? {
               itemCount: 10,
               itemWidth: 264,
               gapWidth: 20
            }
            : isLG
               ? {
                  itemCount: 10,
                  itemWidth: 294,
                  gapWidth: 27
               }
               : {
                  itemCount: 10,
                  itemWidth: 264,
                  gapWidth: 20
               });

   useEffect(() => {
      const abortController = new AbortController();

      const request = new LocationSearchRequest();
      request.latitude = latitude;
      request.longitude = longitude;
      searchClient.execute(request)
         .then(data => {
            setData(
               data.venues
                  .flatMap(venue => venue.workspaceSearchResults.map(workspace => ({ venue, workspace })))
                  .sort((a, b) => (b.workspace.searchScoreHint ?? 0) - (a.workspace.searchScoreHint ?? 0)))
         });

      return () => abortController.abort();
   }, [latitude, longitude]);

   return data.length
      ? <div className={classNames("container", classes.container)}>
         <div className={classes.header}>
            <div className={classes.title}>Spaces you may also like</div>
            <div className={classes.controls}>
               {pager.displayControls && <a href={`/search?latitude=${latitude}&longitude=${longitude}`} target="_blank" className="btn btn-sm btn-arctic-20">View All</a>}
               <ModulePagerControls pager={pager} />
            </div>
         </div>
         <ModulePager
            pager={pager}
            items={data}
            className={classes.pager}
            renderItem={(item, style) =>
               <WorkspaceCard
                  key={item.workspace.id}
                  venue={item.venue}
                  workspace={item.workspace}
                  style={style}
                  tag="a"
                  href={item.workspace.url}
                  target="_blank"
               />}
         />
      </div>
      : null
}

export default SpacesYouMayAlsoLike;